<template>
  <ym-loadmore class="page-category-detail"
               v-model="loading"
               :finished="allLoad"
               @load="fetchData"
  >
    <question-list :title="title"
                   :list="list"
    />
  </ym-loadmore>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import QuestionList from '@/pages/HelpCenter/components/QuestionList';
  import { getFaqCategoryDetail } from '@/services/user';

  export default {
    name: 'PageHelpCenterCategory',
    metaInfo() {
      return {
        title: this.title,
      };
    },
    components: {
      'ym-loadmore': Loadmore,
      QuestionList,
    },
    data() {
      return {
        title: '',
        list: [],
        start: 0,
        allLoad: false,
        loading: false,
        params: null,
      };
    },
    methods: {
      formalFaqList(list) {
        list.map((item) => {
          item.showAnswer = false;
          return item;
        });
        return list;
      },
      async fetchData() {
        if (this.allLoad) return;
        this.loading = true;

        const { start, params } = this;

        const data = await getFaqCategoryDetail({
          limit: 15,
          start,
          categoryId: params.id,
        }, true);
        this.title = data.category.name;
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.start = data.start;
        this.list = this.formalFaqList([...this.list, ...data.list]);

        this.loading = false;
      },
    },
    created() {
      const { params } = this.$route;
      this.params = params;
      this.fetchData();
    },
    beforeRouteUpdate(to, from, next) {
      const { params } = to;
      this.params = params;
      this.fetchData();
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-category-detail {
    height: 100%;
    background: @color-white;
  }
</style>
